import "./dashboard.css";

const ProgressComponent = ({ currentState, complete }) => {
  return (
    <div className="dashboard-progress-item">
      {complete && <div className="dashboard-progress-item-icon">&#10003;</div>}
      {!complete && <div className="dashboard-progress-item-icon-empty"></div>}
      <span className="dashboard-progress-item-text">{currentState}</span>
    </div>
  );
};

export default ProgressComponent;
